import logo from './logo.svg';
import './App.scss';
import HolisticContainer from 'components/HolisticContainer/HolisticContainer'

function App() {
  return (
    <div className="App">
      <HolisticContainer />
    </div>
  );
}

export default App;
